import {axios} from '@/utils/request'

// 获取日程安排列表
export function GetList(data) {
  return axios({
    url: '/jeecg-oa/oa/oaSchedule/getlist',
    method: 'get',
    params: data
  })
}
// 新建日程安排
export function ScheduleCreate(data) {
  return axios({
    url: '/jeecg-oa/oa/oaSchedule/Create',
    method: 'post',
    data
  })
}
// 删除日程安排
export function ScheduleDelete(id) {
  return axios({
    url: `/jeecg-oa/oa/oaSchedule/Delete/${id}`,
    method: 'DELETE',
  })
}
// 获取日历列表
export function GetCalList() {
  return axios({
    url: '/jeecg-oa/oa/oaCalendar/getlist',
    method: 'get',
  })
}
export function ScheduleInfo(params) {
  return axios({
    url: '/jeecg-oa/oa/oaSchedule/queryById',
    method: 'get',
    params
  })
}  
// 更新日程安排
export function ScheduleUpdate(data) {
  return axios({
    url: `/jeecg-oa/oa/oaSchedule/Update/${data.id}`,
    method: 'PUT',
    data
  })
}
// app用
export function AppDayList() {
  return axios({
    url: '/jeecg-oa/oa/oaSchedule/AppDayList',
    method: 'get',
  })
}
export function AppList() {
  return axios({
    url: '/jeecg-oa/oa/oaSchedule/AppList',
    method: 'get',
  })
}
